export enum ServiceProtocol {
    WMS = 'wms',
    WMTS = 'wmts',
    XYZ = 'xyz',
    TILES3D = 'tiles3d',
    QUANTIZEDMESH = 'quantizedmesh',
}
